import type { AnalyticsEvent } from "./events";

// SSR-safe, never-throwing dataLayer access.
//
// GTM may never load: ad blockers and tracker-blocking browsers drop
// googletagmanager.com outright, and VITE_GTM_ID is deliberately unset in
// localdev, so every local session runs without it. `window.dataLayer` is then
// just an array nothing ever drains — which is fine, and is exactly what GTM's
// own snippet creates. Nothing here may affect what renders.

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

// Vite statically replaces this, so the branch is eliminated in production.
const DEBUG = import.meta.env.VITE_ANALYTICS_DEBUG === "true";

/** Idempotent, and a no-op during SSR. Safe with or without GTM present. */
export function ensureDataLayer(): void {
  if (typeof window === "undefined") return;
  try {
    window.dataLayer = window.dataLayer ?? [];
  } catch {
    // Never throw: root.tsx has no ErrorBoundary.
  }
}

ensureDataLayer();

export function pushEvent(event: AnalyticsEvent): void {
  if (typeof window === "undefined") return;
  try {
    ensureDataLayer();
    window.dataLayer?.push(event);
    if (DEBUG) console.info("[analytics] dataLayer.push", event);
  } catch {
    // Never throw.
  }
}
